export const GET_LEADS = "GET_LEADS";
export const ADD_LEAD = "ADD_LEAD";
export const EDIT_LEAD = "EDIT_LEAD";
export const GET_LEAD = "GET_LEAD";
export const RESET_LEAD = "RESET_LEAD";
export const ERROR_LEAD = "ERROR_LEAD";
export const GET_ALL_LEADS = "GET_ALL_LEADS";
                